import * as React from "react";
import { INavigationLink } from "~/components/navigation/navigation-primary-links/navigation-primary-links";

export interface INavigationListProps {
    linkList: INavigationLink[];
    level?: number;
    target?: string;
    label?: string;
    type?: string;
}

const NavigationList: React.SFC<INavigationListProps> = props => {
    const level = props.level || 0;

    const generateLinks = (links: INavigationLink[]): React.ReactNode[] => {
        return links.reduce((generatedLinks: React.ReactNode[], link: INavigationLink, index: number) => {
            if (link.type === "divider") {
                generatedLinks.push(
                    <li key={index} className={"navigation-item level-" + level}>
                        <div className="navigation-item__divider">
                            <span>{link.label}</span>
                        </div>
                    </li>
                );
            }
            if (link.type === "link") {
                generatedLinks.push(
                    <li key={index} className={"navigation-item level-" + level}>
                        <a className="navigation-item__link" href={link.url} target={link.target}>
                            <span>{link.label}</span>
                        </a>
                    </li>
                );
            }
            return generatedLinks;
        }, []);
    };

    const getNavStyling = () => {
        const columns = 2;
        const rowHeight = 42;
        const minHeight = Math.ceil(props.linkList.length / columns) * rowHeight;
        const navigationListStyling: React.CSSProperties = {
            minHeight: minHeight + "px"
        };
        return navigationListStyling;
    };

    return (
        <div className="navigation-list-wrapper" style={getNavStyling()}>
            <ul className={"navigation-list"}>{generateLinks(props.linkList)}</ul>
        </div>
    );
};

export default NavigationList;
